/** @format */

const CmComplaintsDashboard = () =>
  import("@/pages/CM/Complaints/CmComplaintsDashboard.vue");
import MainLayout from "@/pages/CM/MainLayout.vue";
const CmCreateEditViewComplaint = () =>
  import("@/pages/CM/Complaints/CmCreateEditViewComplaint.vue");
const dashboard = () => import("@/pages/CM/dashboardCM.vue");

const hqComplaintsRoutes = [
  {
    path: "dashboard",
    name: "cm-dashboard",
    component: dashboard,
    // beforeEnter: rules.isHQ,
  },
  {
    path: "complaints",
    name: "cm-complaints",
    component: MainLayout,
    children: [
      {
        path: "",
        name: "cm-monitoringOfPracticeFunctionComplaintsDashboard",
        component: CmComplaintsDashboard,
      },
      {
        path: "/:isManager/create/:isEnabled/complaint/:complaintId",
        name: "cm-monitoringOfPracticeFunctionsCreateComplaints",
        component: CmCreateEditViewComplaint,
      },
    ],
  },
];

export default hqComplaintsRoutes;
